import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Home, Search } from 'lucide-react';

export default function NotFound() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
        <div className="max-w-lg w-full bg-white border border-gray-200 shadow-sm p-8 text-center">
          <p className="text-[#c8953d] text-sm font-bold tracking-[0.25em] uppercase">
            LOR95 ADMIN
          </p>

          <h1 className="text-7xl font-serif font-bold text-gray-900 mt-4">
            404
          </h1>

          <h2 className="text-2xl font-semibold text-gray-900 mt-2">
            Faqja nuk u gjet
          </h2>

          <p className="text-gray-500 mt-3">
            Adresa që kërkuat nuk ekziston në panelin e administrimit.
          </p>

          <Link
            to="/admin"
            className="inline-flex items-center justify-center gap-2 mt-7 bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Kthehu te Admin
          </Link>
        </div>
      </div>
    );
  }

  return (
    <main className="min-h-[78vh] bg-[#f8f5f0] flex items-center justify-center px-4 pt-28 pb-16">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-[#b78332] text-xs sm:text-sm font-bold tracking-[0.28em] uppercase">
          LOR95 BOUTIQUE
        </p>

        <h1 className="font-serif text-[90px] sm:text-[130px] leading-none font-bold text-gray-900 mt-3">
          404
        </h1>

        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 -mt-2">
          Faqja nuk u gjet
        </h2>

        <p className="text-gray-500 max-w-lg mx-auto mt-4 leading-relaxed">
          Faqja që po kërkoni mund të jetë zhvendosur, fshirë ose adresa mund të jetë shkruar gabim.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-7 py-3.5 font-semibold transition-colors"
          >
            <Home className="h-4 w-4" />
            Kryefaqja
          </Link>

          <Link
            to="/collections"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-gray-900 text-gray-900 hover:bg-white px-7 py-3.5 font-semibold transition-colors"
          >
            <Search className="h-4 w-4" />
            Shiko Koleksionet
          </Link>
        </div>
      </div>
    </main>
  );
}
